module.exports = __webpack_public_path__ + "img/limpar_pagamentos.00d240da.svg";